export class TenantUtil {
  private static readonly environmentList = ['dev', 'stage', 'prod'];
  private static readonly localDevHosts = ['localhost', '127.0.0.1'];

  static getTenant(topLevelHost: string, environment: string): string {
    if (
      this.environmentList.includes(topLevelHost) ||
      this.localDevHosts.includes(topLevelHost)
    ) {
      return `core.${environment}`;
    }

    return `${topLevelHost}.${environment}`;
  }

  static getCurrentTenant(environment: string): string {
    const topLevelHost = window.location.hostname.split('.')[0];

    return this.getTenant(topLevelHost, environment);
  }
}
